export const DASHBOARD_WIDGETS = [
    "ATTENTION_TASKS",
    "YOUR_RISKS",
    "YOUR_OPPORTUNITIES",
    "OVERDUE_ISSUES",
    "YOUR_ISSUES",
    "YOUR_IMPROVEMENTS",
    "LISTS",
    "ISSUES_CATEGORY",
    "ISSUES_STATUS",
    "YEARLY_CYCLE",
    "MOST_VISITED_PAGES",
    "ANNOUNCEMENTS",
    "SHORTCUTS",
];
